<template lang="pug">
div
  app-modal-visualiza-pdf(
    v-if="showModalVisualizaPdf",
    @closeModal="closeModalVisualizaPdf",
    :titulo="tituloModal",
    :tipo="tipoModal",
    :isImagem="isImagem"
    :conteudo="conteudoModal",
    :conteudoSemId="conteudoModalSemid"
    :isVTN="false"
  )
  app-divider(label="Documentos", :showBorder="true", :addMarginTop="addMarginTop")
  el-table(
    :data="documentos"
  )
    el-table-column(label="Nome do arquivo:", prop="tipoDocumento.descricao", min-width="280")
    el-table-column(label="Tipo de documento", prop="fileName", min-width="250")
    el-table-column(label="Ações", prop="quantidadeUPFPA", width="80")
      template(slot-scope='scope')
        app-action-button(
          v-if="isProcessoFisico"
          :disabled="!isDocumentoParaVisualizacao(scope.row)"
          :cor="!isDocumentoParaVisualizacao(scope.row) ? '#C0C4CC' : '#666666'",
          icone="eye",
          :text="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar' ",
          fontSize="18",
          @click="abrirDocumento(scope.row)"
        )
        app-action-button(
          icone="download",
          text="Download",
          fontSize="18",
          @click="downloadDocumento(scope.row)"
          posicaoTooltip="left"
        )

</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AppActionButton from '../AppActionButton'
import AppDivider from '@/components/AppDivider'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import utils from '@/utils/utils'
const {visualizarDocumentosPDF} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  props: {
    documentos: {
      Type: Array,
      required: true
    },
    idCadastro: {
      Type: Number,
      required: true
    },
    codigoCadastro: {
      Type: String,
      required: false
    },
    addMarginTop: {
      Type: Boolean,
      default: true
    },
    isProcessoFisico: {
      Type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      isLoading: false,
      conteudoModal: '',
      conteudoModalSemid: null,
      tituloModal: '',
      isImagem: false,
      tipoModal: '',
      showModalVisualizaPdf: false
    }
  },

  components: {
    AppActionButton,
    AppDivider,
    AppModalVisualizaPdf
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      baixarDocumento: 'cadastro/downloadDocumentoCentral'
    }),
    downloadDocumento (documento) {
      const payload = {
        owner: this.codigoCadastro,
        idCadastro: this.idCadastro,
        idDocumento: documento.id
      }

      this.baixarDocumento(payload)
    },
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome || row.fileName)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },
    isExtensaoImagem (row) {
      let extensao = utils.getExtensionFile(row.nome || row.fileName)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },
    abrirDocumento (documento) {
      this.tituloModal = 'Visualizar Documento'
      this.tipoModal = 'DOCUMENTO_SEM_ID'
      this.conteudoModal = 0
      this.isImagem = this.isExtensaoImagem(documento)
      this.conteudoModalSemid = {...documento, key: documento.fileKey, id: null}
      this.showModalVisualizaPdf = true
      this.tituloDocumento = documento.tipoDocumento.descricao
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    }
  }
}
</script>
<style lang="scss" scoped>
.pad5 {
  padding: 25px 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/resumo/AppResumoDocumentos.vue